<template>
  <div class="bg-white px-4 py-3 flex items-center justify-between">
    <div class="flex-1 flex justify-between md:hidden">
      <a
        href="#"
        class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
      >
        Previous
      </a>
      <a
        href="#"
        class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"
      >
        Next
      </a>
    </div>
    <div class="hidden md:flex-1 md:flex md:items-center md:justify-between">
      <div class="flex items-center justify-center">
        <div class="text-sm flex items-center justify-center">
          <SelectField
            class="w-[100px] col-span-6 md:col-span-2 mr-2"
            v-model="itemPerPageLocal"
            placeholder="Select the backorder"
            :options="[
              { value: '10', label: '10/Page' },
              { value: '20', label: '20/Page' },
              { value: '30', label: '30/Page' },
              { value: '40', label: '40/Page' }
            ]"
          />
        </div>
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium"> {{ from }} </span>
          to
          <span class="font-medium"> {{ to }} </span>
          of
          <span class="font-medium"> {{ total }} </span>
          results
        </p>
      </div>
      <div>
        <nav
          class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <a
            href="#"
            class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            @click="navigate('prev')"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </a>
          <a
            href="#"
            class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            @click="navigate('next')"
          >
            <span class="sr-only">Next</span>
            <!-- Heroicon name: solid/chevron-right -->
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import SelectField from "@/components/Shared/Input/SelectField";

export default {
  name: "TableNavigation",
  components: {
    SelectField
  },
  props: {
    from: {
      type: Number,
      required: true
    },
    to: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    navigate: {
      type: Function,
      required: true
    },
    itemPerPage: {
      type: Number
    }
  },
  computed: {
    itemPerPageLocal: {
      get: function () {
        return this.itemPerPage;
      },
      set: function (val) {
        this.$emit("update:itemPerPage", parseInt(val));
      }
    }
  }
};
</script>
